import step1 from './steps/step1.webp';
import step2 from './steps/step2.webp';
import step3 from './steps/step3.webp';

export const STEP_CARD_IMAGES = [step1, step2, step3];
